function getExistingAttributionParams() {
  if (typeof window === 'undefined') return {}
  const existingParams = sessionStorage.getItem('dynamicApplyParamsHistory')
  return existingParams ? JSON.parse(existingParams) : {}
}

function updateDynamicParamsFromURL(dynamicApplyParams) {
  if (typeof window === 'undefined' || !dynamicApplyParams) {
    return
  }

  const dynamicParamsHistory = getExistingAttributionParams()
  const lowerToProper = {}

  dynamicApplyParams.forEach(param => {
    lowerToProper[param.toLowerCase()] = param
  })

  const searchParamsExists = new URLSearchParams(window.location.search).size > 0

  if (!searchParamsExists) return

  if (Object.keys(dynamicParamsHistory).length > 0) {
    sessionStorage.removeItem('dynamicApplyParamsHistory')
  }

  new URLSearchParams(window.location.search).forEach((value, key) => {
    const properKey = lowerToProper[key.toLowerCase()]
    if (properKey !== undefined) {
      dynamicParamsHistory[properKey] = value
    }
  })
  sessionStorage.setItem('dynamicApplyParamsHistory', JSON.stringify(dynamicParamsHistory))
}

function saveAttributionParams(dynamicApplyParams, extraApplyParams) {
  updateDynamicParamsFromURL(dynamicApplyParams)

  return {
    dynamicApplyParams,
    extraApplyParams: extraApplyParams ? JSON.parse(extraApplyParams.internal.content) : null
  }
}

export { saveAttributionParams, getExistingAttributionParams }
